import api from '../../api';

export const getTools = (params = {}) => {
  return api.get('/tools', {
    params: {
      ...params,
    },
  });
};
